/**
 * /no-tenants — порожній стан після login.
 *
 * Користувач залогінений, але /my-tenants повернув [] — у нього немає
 * жодного активного membership. Можливі причини:
 *  - Всі membership були suspended/deleted власниками інших tenant'ів.
 *  - User щойно зареєструвався окремо і не долучений до жодного tenant.
 *
 * Пропонуємо 3 варіанти за спецою (розд. 1.3):
 *  - Створити власний tenant (→ /signup-tenant).
 *  - Попросити запрошення в адміністратора (інформація).
 *  - Зв'язатися з підтримкою (placeholder).
 */
import { Link } from 'react-router-dom';
import { leaveSession } from '@/auth/store';
import { logout as apiLogout } from '@/api/auth';

export default function NoTenantsPage() {

  async function handleLogout() {
    try { await apiLogout(); } catch { /* вихід однаково */ }
    leaveSession();   // ч.1229: вихід — з повним перезавантаженням сторінки
  }

  return (
    <div className="login">
      <div
        className="card"
        style={{ width: 520, padding: '2rem', background: 'var(--bg-panel)' }}
      >
        <h2 style={{ marginTop: 0 }}>Розпочнімо роботу</h2>
        <p style={{ color: 'var(--text-secondary)' }}>
          Створіть власний бізнес або скористайтеся запрошенням від колеги.
        </p>

        <div style={{ marginTop: '1.5rem' }}>
          <h3>Варіанти:</h3>
          <ul style={{ paddingLeft: '1.2rem', lineHeight: 1.7 }}>
            <li>
              <strong>Створити власний бізнес.</strong>{' '}
              <Link to="/signup-tenant">Створити tenant</Link>
            </li>
            <li>
              <strong>Попросити запрошення</strong> в адміністратора свого
              робочодавця і відкрити отриманий лист.
            </li>
            <li>
              <strong>Зв'язатися з підтримкою</strong> — якщо ви впевнені, що
              мали доступ.
            </li>
          </ul>
        </div>

        <div style={{ marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid var(--border-soft)' }}>
          <button type="button" onClick={handleLogout}>
            Вийти
          </button>
        </div>
      </div>
    </div>
  );
}
